<template>
	<dt
		:class="[labelClass, 'truncate text-sm font-medium text-gray-500']">
		{{ props.label }}
	</dt>
	<div v-show="!loading">
		<dd
			v-if="$slots.custom"
			class="truncate w-full">
			<slot name="custom" />
		</dd>
		<dd
			v-else
			:class="[valueClass, 'mt-1 text-3xl font-semibold tracking-tight text-gray-900 flex items-baseline gap-x-2']">
			<slot />
			<span
				v-if="unit"
				class="text-sm text-gray-500 font-medium">{{ unit }}</span>
		</dd>
	</div>
	
	<div v-show="loading">
		<div class="mt-6 h-4 rounded-full bg-gray-300 animate-pulse w-full" />
	</div>
</template>

<script lang="ts">
	export default { name: 'SimpleStat' } // name the component
</script>

<script setup lang="ts">
	const props = defineProps({ 
		badge: {
			type: Boolean,
			default: false
		},
		editing: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		labelClass: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: '—'
		},
		value: {
			type: [ String, Number ],
			default: null
		},
		valueClass: {
			type: String,
			default: ''
		},
		unit: {
			type: String,
			default: ''
		}
	})
</script>
